module.exports = __webpack_public_path__ + "static/media/mediumThumbNoImageFood.e510057e.png";